export const Logo = ({ size = 40 }) => (
  <img
    src="/logo.png"
    alt="AutoBay logo"
    width={size}
    height={size}
    className="rounded-lg shrink-0"
    style={{ width: size, height: size }}
  />
);

export default Logo;
